import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "../../../mocks/faq";

export default function FaqTeaser() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const preview = faqs.slice(0, 4);

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 pb-14 md:pb-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
        <div>
          <span className="text-xs font-semibold tracking-widest text-accent-500">FAQ</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            追更同人常见问题
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-400">
            关于作品库的更新、收录原则与使用方式，这里都有答案。更多问题可前往常见问题页面查看。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 rounded-md border border-background-300/70 px-5 py-2.5 text-sm font-medium text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-300 whitespace-nowrap"
          >
            查看全部常见问题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="divide-y divide-background-300/60 rounded-lg border border-background-300/60 bg-background-100">
          {preview.map((f, i) => (
            <div key={f.q}>
              <button
                type="button"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                aria-expanded={openIndex === i}
              >
                <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">
                  {f.q}
                </span>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300/70 text-foreground-400 transition-transform ${openIndex === i ? "rotate-45 text-primary-300" : ""}`}>
                  <i className="ri-add-line" />
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === i ? "max-h-64 pb-4" : "max-h-0"}`}
              >
                <p className="px-5 text-sm leading-relaxed text-foreground-400">{f.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}